//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../../ApiService";

const DetailsService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/sentence/details/loadscreenview", { id }, successCallback, failureCallback);
    },
    previousOrNext: (id, previousOrNext, level, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/sentence/details/previousornext", { id, previousOrNext, level }, successCallback, failureCallback);
    },
};

export default DetailsService;
